/**
 * Store: Site Header
 * -----------------------------------------------------------------------------
 *
 */

export default {
  namespaced: true,

  state: () => ({
    height: 0,
  }),
  getters: {
    getHeight: (state) => state.height,
  },
  mutations: {
    SET_HEIGHT(state, height) {
      state.height = height
    },
  },
  actions: {
    setHeight({ commit }, height) {
      commit('SET_HEIGHT', height)
    },
    setHeightDebounced({ commit }, height) {
      commit('SET_HEIGHT', height)
    },
  },
}
